import {readAndroidRuntimeIdentity} from './smt-device-gate-bootstrap-consumer.ts';

export interface RuntimeReadyBridge{
  readonly postMessage:(message:string)=>void;
}

declare global{
  interface Window{
    moreFunNative?:RuntimeReadyBridge;
  }
}

export function signalAndroidRuntimeReady(
  url:URL,
  bridge:RuntimeReadyBridge|undefined=typeof window!=='undefined'?window.moreFunNative:undefined,
):boolean{
  const identity=readAndroidRuntimeIdentity(url);
  if(!identity||!bridge)return false;
  bridge.postMessage(JSON.stringify({
    type:'runtime.ready',
    bridgeVersion:1,
    releaseId:identity.releaseId,
  }));
  return true;
}
